import { Control, Controller, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { isValidUrl } from 'utilitys/helpers/general';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/addAssociatedDocuments';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addLinkToFile/AddLinkToFile.module.scss';
import { Button } from 'components/DesignSystem/Button';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { CustomizedFormErrorMessage } from 'components/common';

interface Props {
    control: Control<IFields, any, IFields>;
    handleCancel: () => void;
    errors: FieldErrors<IFields>;
    setValue: UseFormSetValue<IFields>;
}

export const AddLinkToFile = ({ control, handleCancel, setValue, errors }: Props) => {
    return (
        <div className={classes.addLinkToFileWrapper}>
            <div className={classes.inputsWrapper}>
                <div>
                    <div className={classes.inputTitle}>External Link Title</div>

                    <Controller
                        render={({ field }) => (
                            <TextInput
                                {...field}
                                placeholder={''}
                                maxLength={50}
                                onClear={() => {
                                    setValue('externalLink.title', '');
                                }}
                            />
                        )}
                        name={'externalLink.title'}
                        control={control}
                        rules={{
                            validate: {
                                min: (value) => (value && value.length > 1) || 'must be at least 2 characters',
                            },
                        }}
                    />
                    {errors.externalLink?.title && (
                        <CustomizedFormErrorMessage text={errors.externalLink.title.message} />
                    )}
                </div>
                <div>
                    <div className={classes.inputTitle}>External Link target</div>
                    <Controller
                        render={({ field }) => (
                            <TextInput
                                {...field}
                                placeholder={''}
                                maxLength={1000}
                                onClear={() => {
                                    setValue('externalLink.url', '');
                                }}
                            />
                        )}
                        name={'externalLink.url'}
                        control={control}
                        rules={{
                            validate: {
                                min: (value) => isValidUrl(value.trim()) || 'invalid link',
                            },
                        }}
                    />
                    {errors.externalLink?.url && <CustomizedFormErrorMessage text={errors.externalLink.url.message} />}
                </div>
            </div>

            <div className={classes.footer}>
                <div className={classes.container}>
                    <Button size={'large'} variant={'secondary'} onClick={handleCancel}>
                        Cancel
                    </Button>

                    <Button size={'large'} variant={'primary'} type={'submit'}>
                        Add
                    </Button>
                </div>
            </div>
        </div>
    );
};
